import {ServerError} from "~/utils/ServerError";

export const apiErrorHandler = (error) => {
  if (error.response) {
    console.info("entra aquí")
    const response = error.response
    if (response.status === 429) {
      throw new ServerError('too_many_requests', null, 429)
    } else if (response.status === 403 && response.data?.message === 'customer_disabled') {
      throw new ServerError('customer_disabled', null, 403)
    } else {
      const message = error.response.data.code?.toLowerCase() || error.response.data.message?.toLowerCase()
      throw new ServerError(
        message,
        error.response.data.payload,
        error.response.status
      )
    }
  } else {
    throw new ServerError(error.code?.toLowerCase() || error.message?.toLowerCase())
  }
}
